/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { Record } from 'immutable'
import StripeKeyEvent from '../../event/StripeKeyEvent'

const StripeKeySearchConditionState = Record({
  search_keywords: '',
  search_hotel_ids: null
})

class StripeKeySearchStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new StripeKeySearchConditionState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case StripeKeyEvent.onEditSearchCondition:
        return state.set(payload.name, payload.value)

      default:
        return state
    }
  }
}

export default new StripeKeySearchStore()
